import { render } from "./DadosPessoais.vue?vue&type=template&id=1afba43c&scoped=true&ts=true"
import script from "./DadosPessoais.vue?vue&type=script&lang=ts"
export * from "./DadosPessoais.vue?vue&type=script&lang=ts"

import "./DadosPessoais.vue?vue&type=style&index=0&id=1afba43c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afba43c"]])

export default __exports__